import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 15, height: 15, rx: 3.5, style: {
  fill: "var(--neutral-text-weak)",
  stroke: "var(--neutral-border)"
}, fillOpacity: 0.08 }));
const ForwardRef = forwardRef(SvgCheckbox);
export { ForwardRef as ReactComponent };
